export default "__VITE_ASSET__CxZLRFF6__";